import { DevelopmentPathCycleStateDto } from '@/api/generated';

export type ToStateOptionsDictionariesTranslation = Record<DevelopmentPathCycleStateDto, string>;

export const toStateOptionsDictionariesTranslation: ToStateOptionsDictionariesTranslation = {
  [DevelopmentPathCycleStateDto.Archived]: 'Historyczny',
  [DevelopmentPathCycleStateDto.Cancelled]: 'Anulowany',
  [DevelopmentPathCycleStateDto.Completed]: 'Zrealizowany',
  [DevelopmentPathCycleStateDto.Draft]: 'Utworzono szkic',
  [DevelopmentPathCycleStateDto.ReadyForRealization]: 'Gotowy do realizacji',
  [DevelopmentPathCycleStateDto.SupervisorApproved]: 'Zatwierdzony przez przełożonego',
  [DevelopmentPathCycleStateDto.SupervisorRejected]: 'Odrzucony przez przełożonego',
};
